"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const libs_hooks_react_1 = require("@hotelplan/libs.hooks-react");
const fdr_catalogs_modals_styles_1 = require("./fdr-catalogs-modals.styles");
const fdr_catalogs_modals_utils_1 = require("./fdr-catalogs-modals.utils");
const ErrorNotification = () => {
    const [t] = (0, next_i18next_1.useTranslation)('catalogs');
    return (react_1.default.createElement(fdr_catalogs_modals_styles_1.ErrorNotificationWrap, null,
        react_1.default.createElement("div", { className: "notification-content" },
            react_1.default.createElement("p", { className: "text" }, t('catalogs:error.text')))));
};
function FdrCatalogsModals({ api, orderSuccess, loading, }) {
    const [t] = (0, next_i18next_1.useTranslation)();
    const [showResultModal, openResultModal, closeResultModal] = (0, libs_hooks_react_1.useToggleState)();
    const [showErrorModal, openErrorModal, closeErrorModal] = (0, libs_hooks_react_1.useToggleState)(false);
    const orderResultNotificationData = typeof orderSuccess !== 'undefined'
        ? (0, fdr_catalogs_modals_utils_1.getOrderResultNotificationData)(orderSuccess)
        : null;
    if (api) {
        api.current = {
            openResultModal,
            openErrorModal,
        };
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        orderResultNotificationData ? (react_1.default.createElement(fdr_catalogs_modals_styles_1.CatalogsResultModal, { name: "catalogsResultModal", type: orderResultNotificationData.type, title: t(orderResultNotificationData.title), show: showResultModal, onClose: closeResultModal }, t(orderResultNotificationData.text))) : null,
        react_1.default.createElement(fdr_catalogs_modals_styles_1.CatalogErrorModal, { show: showErrorModal, onClose: closeErrorModal, title: t('catalogs:error.title') },
            react_1.default.createElement(ErrorNotification, null)),
        react_1.default.createElement(fdr_catalogs_modals_styles_1.CatalogLoadingModal, { show: loading, title: t('catalogs:order.loading') })));
}
exports.default = FdrCatalogsModals;
//# sourceMappingURL=fdr-catalogs-modals.js.map